export let dataAsuransi = {
  title: "Cara Pembayaran",
  backBtn: "",
  actionBtn: [

  ],
  breadcrumb: []
};
export let dataDokter = {
  title: "Dokter",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Dokter Baru",
      link: "/master/dokter/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataUser = {
  title: "User",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "User Baru",
      link: "/master/user/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataKamar = {
  title: "Kamar Rawat Inap",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Kamar Baru",
      link: "/master/kamar/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataPenyakit = {
  title: "Klasifikasi Medis",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Klasifikasi Baru",
      link: "/master/penyakit/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataPetugas = {
  title: "Petugas",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Petugas Baru",
      link: "/master/petugas/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataJadwalDokter = {
  title: "Jadwal Dokter",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Jadwal Dokter Baru",
      link: "/master/jadwal-dokter/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataOptikItem = {
  title: "Optik",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-outline-secondary  btn-with-icon-left",
      label: "Sync",
      type: "function",
      function:()=>{},
      iconLeft: "sync"
    },
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Item Optik Baru",
      link: "/master/optik-item/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataObat = {
  title: "Obat / Alkes",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Obat / Alkes Baru",
      link: "/master/obat/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataTindakan = {
  title: "Tindakan",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Tindakan Baru",
      link: "/master/tindakan/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataProvinsi = {
  title: "Provinsi",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Provinsi Baru",
      link: "/master/provinsi/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};

export let dataBank = {
  title: "Bank",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Bank Baru",
      link: "/master/bank/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};

export let dataAsuransiLain = {
  title: "Asuransi",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Asuransi Baru",
      link: "/master/asuransi-lain/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};

export let dataKota = {
  title: "Kota",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Kota Baru",
      link: "/master/kota/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataKecamatan = {
  title: "Kecamatan",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Kecamatan Baru",
      link: "/master/kecamatan/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataKelurahan = {
  title: "Kelurahan",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Kelurahan Baru",
      link: "/master/kelurahan/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataFaskes = {
  title: "Faskes",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Faskes Baru",
      link: "/master/faskes/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataLokasi = {
  title: "Lokasi",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Lokasi Baru",
      link: "/master/lokasi/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataUnit = {
  title: "Unit",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Unit Baru",
      link: "/master/unit/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataPeriksaLab = {
  title: "Periksa Lab",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Periksa Lab Baru",
      link: "/master/periksa-lab/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let dataPeriode = {
  title: "Periode",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Periode Baru",
      link: "/master/periode/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let tabs = [
  { title: "SEMUA", filter: "", active: true },
  { title: "UMUM", filter: 1 },
  { title: "BPJS", filter: 2},
  { title: "ASURANSI LAIN", filter:3}
];
export let sorts = [
  {
    value: "desc",
    label: "Terbaru"
  },
  {
    value: "asc",
    label: "Terlama"
  }
];
export let filters = {
  colnum: "",
  columns: [
    {
      label: "tanggal",
      type: "date",
      placeholder: "Tanggal Dibuat",
      name: "created_at",
      value: "",
      mandatory: true,
      colwidth: 8,
      id: "filterDate"
    }
  ]
};
export let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      name:"orderBy",
      placeholder: "",
      value: "desc",
      mandatory: true,
      options: sorts
    }
  ]
};

export let dataWilayahKota = {
  title: "Kota",
  backBtn: "/master/provinsi",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Kota Baru",
      link: "/master/kota/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: [
      { title: "Seluruh Provinsi", link: "/master/provinsi" },
      { title: "Data Kota / Kabupaten", active: true }
  ]
};
export let dataWilayahKecamatan = {
  title: "Kecamatan",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Kecamatan Baru",
      link: "/master/kecamatan/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: [
      { title: "Seluruh Provinsi", link: "/master/provinsi" },
      { title: "Data Kota / Kabupaten", link: "" },
      { title: "Data Kecamatan", active: true }
  ]
};
export let dataWilayahKelurahan = {
  title: "Kelurahan",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Kelurahan Baru",
      link: "/master/kelurahan/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: [
      { title: "Seluruh Provinsi", link: "/master/provinsi" },
      { title: "Data Kota / Kabupaten", link: "" },
      { title: "Data Kecamatan", link: "" },
      { title: "Data Desa / Kelurahan", active: true }
  ]
};